import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from 'src/app/core/toast.service';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ProfileService } from '../../services/profile.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.scss']
})
export class VerifyOtpComponent implements OnInit {

  otpForm:FormGroup

  otpVerify = {
    email:null,
    type:null,
    otp:null
  }

  responceData:any;
  invalidotp:boolean=false

  constructor(private _dialogRef: MatDialogRef<VerifyOtpComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data:any,
    private toast:ToastService,private _fb: FormBuilder,private profileService:ProfileService,private spinner: NgxSpinnerService) { }

  ngOnInit(): void {


    this.otpForm = this._fb.group({
      otp: [null, [Validators.required]],
      
    });

  }

  dialogClose(){

    // this._dialogRef.close()
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(); }, 1000);

  }


  changeStatus(){

    if (this.otpForm.invalid) {
      this.invalidotp=true
      // this.toast.openSnackBar(
      //   'Enter Valid OTP'
      // );
      //this.clearForm = true;
      this.otpForm.markAllAsTouched();
      return;
    }

    this.spinner.show()

    console.log(this.otpForm.value)

    this.otpVerify.email = this.data.userData.email
    this.otpVerify.type = this.data.userData.type
    this.otpVerify.otp = this.otpForm.value.otp

    this.profileService.verifyOtp(this.otpVerify).then(data=>{
      console.log(data)
      this.responceData = data
      if(this.responceData.status == 'success'){

        this.spinner.hide()

        if(this.data.userData.type == "PROFESSIONAL"){

          this.profileService.updateProf(this.data.id,this.data.updatedData).then(data=>{
            console.log(data)

            if(data){
              this.dialogClose()
            }
          })

        }

        if(this.data.userData.type == "SUPPLIER"){

          this.profileService.updateSupplier(this.data.id,this.data.updatedData).then(data=>{
            console.log(data)
            if(data){
              this.dialogClose()
            }
          })

        }

        if(this.data.userData.type == "PRACTICE"){

          this.profileService.updatePractice(this.data.id,this.data.updatedData).then(data=>{
            console.log(data)
            if(data){
              this.dialogClose()
            }
          })

        }



      }else{
        this.spinner.hide()
        this.toast.openSnackBar(
          'Incorrect OTP'
        );
      }
    })

  }
}
